<img height="75" src="https://www.flacriminallawyer.com/wp-content/uploads/2015/12/Fort-Lauderdale-Criminal-Attorney-Jonathan-Friedman-Logo.jpg" />
<br /><br />

<h3>Document Upload & Case Details Extraction</h3>
<p>Upload a PDF document to extract case details automatically using AI.
  <b>Content generated by AI. Please verify important information independently</b>
</p>

<div class="upload-container">
  <div class="upload-area" 
       (dragover)="onDragOver($event)"
       (dragleave)="onDragLeave($event)"
       (drop)="onFileDropped($event)"
       [class.has-file]="selectedFile">
    
    <div *ngIf="!selectedFile" class="upload-placeholder">
      <i class="fas fa-cloud-upload-alt fa-3x"></i>
      <p>Drop your PDF file here or click to browse</p>
      <input type="file" 
             accept=".pdf" 
             (change)="onFileSelected($event)" 
             style="display: none;" 
             #fileInput>
      <button class="btn btn-secondary" (click)="fileInput.click()">Choose File</button>
    </div>
    
    <div *ngIf="selectedFile" class="file-selected">
      <i class="fas fa-file-pdf fa-2x"></i>
      <p><strong>{{ selectedFile.name }}</strong></p>
      <p>{{ (selectedFile.size / 1024 / 1024).toFixed(2) }} MB</p>
      <button class="btn btn-secondary" (click)="selectedFile = null; uploadError = ''">Remove</button>
    </div>
  </div>

  <div *ngIf="uploadError" class="alert alert-danger">
    {{ uploadError }}
  </div>

  <div class="action-buttons">
    <button class="btn btn-primary" 
            [disabled]="!selectedFile || busyUploading" 
            (click)="uploadAndParseDocument()">
      <span *ngIf="busyUploading">
        <i class="fas fa-spinner fa-spin"></i> Parsing Document...
      </span>
      <span *ngIf="!busyUploading">
        <i class="fas fa-magic"></i> Parse Document
      </span>
    </button>
  </div>
</div>

<br /><br /><br /><br /><br /><br /><br />
